import React from "react";

export const ColorPicker = ({ colors, value, onChange }) => (
  <div className="mt-10">
    <div className="flex items-center justify-between mb-3">
      <span className="micro-label text-[#1a1814]/60">Colour</span>
      <span className="text-sm font-serif italic">{value}</span>
    </div>
    <div className="flex flex-wrap gap-2">
      {colors.map((c) => (
        <button
          type="button"
          key={c}
          onClick={() => onChange(c)}
          className={`px-4 py-2 micro-label border ${
            value === c ? "border-[#1a1814] bg-[#1a1814] text-[#f0e9e1]" : "border-[#1a1814]/20 hover:border-[#1a1814]"
          }`}
          data-testid={`color-option-${c.toLowerCase()}`}
        >
          {c}
        </button>
      ))}
    </div>
  </div>
);
